








































































































































































































































































































































































import { BaseModel } from "@/models/products/base";
import { Component, Watch } from "vue-property-decorator";
import Items from "./Items";
import RadioButtonBox from "@/components/elements/utility/RadioButtonBox.vue";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import { BaseOrderRecord, LineItem, Note } from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import { ConfigFile } from "@/models/configurator/config_file";
import AddToQuoteFooter from "@/components/footer/AddToQuoteFooter.vue";
import ProductService from "@/services/product_service";
import { AuthError, GenericError } from "@/services/error_service";
import FabricSelector from "@/components/items/fabric_picker/FabricSelector.vue";
import MiniSwatch from "@/components/elements/products/MiniSwatch.vue";
import { CustomBaseOrder } from "@/models/configurator/custom_umbrella";
import { ProductLineName } from "@/models/products/collection";
import { UmbrellaType } from "@/models/products/umbrella";
import { Validations } from "vuelidate-property-decorators";
import { required, requiredIf } from "vuelidate/lib/validators";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";
import { NoteFields } from "@/models/order/helpers";
import { FinishHandle } from "@/models/products/finish";
import DropdownFinishes from "@/components/elements/utility/DropdownFinishes.vue";
import Dropdown from "@/components/elements/utility/Dropdown.vue";
import SpecsModal from "@/components/elements/modal/SpecsModal.vue";
import { getFinishImage } from "@/utility/helpers";
import { GlobalActions } from "@/store/modules/global/types";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { StoreModule } from "@/store/types";
import { namespace } from "vuex-class";
@Component({
  components: {
    AccordionSection,
    RadioButtonBox,
    AddToQuoteFooter,
    FabricSelector,
    MiniSwatch,
    FormValidation,
    DropdownFinishes,
    Dropdown,
    SpecsModal
  }
})
export default class CustomizeBase extends Items {
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;

  protected spigotValue = "Spigot";
  protected spigotNote = "Intended for Spigot use - No stem requested.";
  protected beautyPlateNote = "Beauty plate included.";
  protected getFinishImage = getFinishImage;
  protected ProductLineName = ProductLineName;
  protected index: null | number = 0;
  protected ProductType = ProductType;
  protected showSpecsModal = false;
  protected item_details: CustomBaseOrder = {
    base: {
      base: null,
      baseFinish: {
        display_name: null as any,
        handle: null as any
      },
      baseStem: null,
      baseOptions: { wheels: false }
    },
    notes: []
  };

  protected productService = new ProductService();
  protected itemPrice = 0;
  protected sku = "";
  protected noteObj = {
    finish: "",
    stem: "",
    options: ""
  };
  protected showNoteModal = {
    finish: false,
    stem: false,
    options: false
  };

  @Watch("item_details.base.base")
  private async onBaseChange(): Promise<void> {
    await this.updatePrice();
    await this.updateSKU();
  }

  @Watch("item_details.base.baseFinish.handle")
  private async onFinishChange(): Promise<void> {
    await this.updatePrice();
    await this.updateSKU();
  }

  @Watch("item_details.base.baseOptions.wheels")
  private async onWheelChange(): Promise<void> {
    await this.updatePrice();
    await this.updateSKU();
  }

  @Watch("item_details.base.baseStem")
  private async onStemChange(): Promise<void> {
    await this.updatePrice();
    await this.updateSKU();
  }

  /** ALl custom validations should evaluate to true to submit form. Invalid = false */
  @Validations()
  validations() {
    return {
      item_details: {
        base: {
          base: { required },
          baseFinish: { required },
          baseStem: {
            required: requiredIf(
              () =>
                this.item_details.base.base!.mounts &&
                this.item_details.base.base!.mounts.length > 0
            )
          }
        }
      }
    };
  }

  async created() {
    if (!this.$route.params.edit && this.$route.query.cart) {
      // if a user refreshes or back buttons onto this page, redirect to expired notice. because we are using index to update item, the user must navigate directly from the cart, or we can't guarantee the index is correct
      this.$router.replace("/resubmit");
    } else if (this.$route.params.edit && this.$route.query.cart) {
      this.editMode = true;
      const index = parseInt(this.$route.query.cart as string, 10);
      await this.prepDataForEdit(index);
    } else {
      await this.setDefaults();
    }
    this.setNotes();
    this.$emit("ready");
  }

  protected closeSpecsModal(): void {
    this.showSpecsModal = false;
  }

  protected toggleSpecsModal(): void {
    this.showSpecsModal = true;
  }

  protected async prepDataForEdit(index: number): Promise<void> {
    this.item_details = Object.assign(
      {},
      { ...this.storeItems[index].item_details }
    ) as CustomBaseOrder;
    if (this.item_details.notes && this.item_details.notes.length > 0) {
      this.setNotes();
    } else {
      this.item_details.notes = [];
    }
  }

  protected mobileSetFinish(handle: FinishHandle): void {
    this.item_details.base.baseFinish!.handle = handle;
  }

  protected setNotes(): void {
    const bf = ["finish", "stem", "model", "options"];
    bf.forEach(field => {
      const obj = this.item_details.notes!.find(e => e.field === field);
      if (obj) {
        let content = obj.content;
        if (field === "stem") {
          content = content.replace(this.spigotNote, "").trim();
          content = content.replace(this.beautyPlateNote, "").trim();
        }
        this.noteObj[field] = content;
      }
    });
  }

  protected addNotesToQuote(): void {
    this.item_details.notes = [];
    for (const [key, value] of Object.entries(this.noteObj)) {
      let content = value;
      if (key === "stem" && this.isSpigotSelected) {
        content = content ? `${this.spigotNote} ${content}` : this.spigotNote;
      }
      if (key === "stem" && this.isBeautyPlateIncluded) {
        content = content
          ? `${this.beautyPlateNote} ${content}`
          : this.beautyPlateNote;
      }
      this.item_details.notes.push({
        field: key as NoteFields,
        content
      });
    }
  }

  get vBaseObject() {
    return this.$v.item_details.base;
  }

  protected async setDefaults(): Promise<void> {
    this.item_details.base.base = (await this.getItem(
      this.handle
    )) as BaseModel;
    this.item_details.base.baseFinish!.handle = this.finishes[0].handle;
  }

  protected async updatePrice(): Promise<void> {
    try {
      const price = await this.productService.getBasePrice({
        model: this.item_details.base.base!.model,
        item_details: {
          ...this.item_details.base,
          base: this.item_details.base.base!,
          baseFinish: this.item_details.base.baseFinish!.handle,
          baseStem: this.isSpigotSelected
            ? null
            : this.item_details.base.baseStem
        }
      });
      this.itemPrice = price.base!;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup(err.message);
    }
  }

  protected async updateSKU(): Promise<void> {
    const data = this.transformDataToConfigFile();
    const sku = await this.productService.createBaseSKU(data);
    this.sku = sku;
  }

  protected get isSpigotSelected(): boolean {
    return this.item_details.base.baseStem === this.spigotValue;
  }

  protected get isBeautyPlateIncluded(): boolean {
    return (
      this.needsSpigotOption &&
      !this.isSpigotSelected &&
      !!this.item_details.base.baseStem
    );
  }

  protected transformDataToConfigFile(): ConfigFile {
    return {
      base: {
        base: this.item_details.base.base?.model ?? null,
        baseFinish: this.item_details.base.baseFinish?.handle ?? null,
        baseStem: this.isSpigotSelected
          ? null
          : this.item_details.base.baseStem ?? null,
        baseOptions: this.item_details.base.baseOptions
      }
    } as ConfigFile;
  }

  protected addToQuote(item: LineItem) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.addNotesToQuote();
      const orderItem = { ...item, item_details: this.item_details };
      orderItem.sku = this.sku;
      this.addItem(orderItem);
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      const baseOptions = { ...orderItem.item_details.base.baseOptions };
      if (orderItem.item_details.base.baseStem) {
        if ((orderItem.item_details.base.baseStem as any) === "Spigot") {
          baseOptions["attachment"] = orderItem.item_details.base.baseStem;
        } else {
          baseOptions["stem"] = orderItem.item_details.base.baseStem;
        }
      }
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        model: orderItem.model,
        name: orderItem.display_name,
        finish: orderItem.item_details.base.baseFinish!.handle,
        options: baseOptions,
        sku: orderItem.sku,
        cost: numberPrice
      });
      this.editMode = true;
    }
  }

  protected editQuote(item: LineItem) {
    const index = parseInt(this.$route.query.cart as string, 10);
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.addNotesToQuote();
      const orderItem = { ...item, item_details: this.item_details };
      orderItem.sku = this.sku;
      this.editLineItem({ item: orderItem, index: index });
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      const baseOptions = { ...orderItem.item_details.base.baseOptions };
      if (orderItem.item_details.base.baseStem) {
        if ((orderItem.item_details.base.baseStem as any) === "Spigot") {
          baseOptions["attachment"] = orderItem.item_details.base.baseStem;
        } else {
          baseOptions["stem"] = orderItem.item_details.base.baseStem;
        }
      }
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        model: orderItem.model,
        name: orderItem.display_name,
        finish: orderItem.item_details.base.baseFinish!.handle,
        options: baseOptions,
        sku: orderItem.sku,
        cost: numberPrice
      });
    }
  }

  protected toggleModal(field: string): void {
    this.showNoteModal[field] = true;
  }

  protected closeModal(): void {
    this.showNoteModal = {
      finish: false,
      stem: false,
      options: false
    };
  }

  get needsSpigotOption(): boolean {
    const base = this.item_details.base.base;
    if (!base || !base.product_lines) return false;
    return base.product_lines.some(
      pl =>
        pl.umbrella_type === UmbrellaType.Cantilever ||
        pl.display_name === "Nova"
    );
  }

  get stemDropdownData(): { model: string }[] {
    const mounts = this.item_details.base.base?.mounts || [];
    if (this.needsSpigotOption) {
      return [{ model: this.spigotValue }, ...mounts];
    }
    return [...mounts];
  }

  get finishes(): BaseModel["finishes"] {
    return this.item_details.base.base!.finishes.sort((a, b) =>
      a.handle > b.handle ? 1 : -1
    );
  }
}
